import React from "react";
import styles from "./box.module.scss";
import { Link } from "react-router-dom";
import { FaFileDownload } from "react-icons/fa";
import { FaHandHoldingHeart } from "react-icons/fa";
//------------------------------------------
import {docsData ,docsData_2,docsData_3,docsData_4} from './data' ;
import {docsData_5,docsData_6,docsData_7,docsData_8 } from './data' ;
import {docsData_9,docsData_10,docsData_11,docsData_12} from './data' ;
import {docsData_13,docsData_14,docsData_15,docsData_16} from './data' ;

const DocItem = ({arr ,title})=>{
  return(
    <div className={styles.docItem} >
      <strong className={styles.__strong}>
        {title} 
      </strong>
      {
        arr.map((ele,i)=>{return(
          <button className={styles["product___btn"]} key={i}>
            <a href={ele.link} download target='_blank' rel="noreferrer" ><FaFileDownload/> | {ele.linkName}</a>
          </button>
        )})
      }
    </div>
  )
}

//-----------------------------------
const Box = ({section}) => {
  let array_1,array_2,array_3,array_4,title_1,title_2,title_3,title_4;
  if(section === 'Presentations and Demos'){
    array_1 = docsData;
    title_1 = 'Brochures';
    array_2 = docsData_2;
    title_2= 'Brochures';
    array_3 = docsData_3;
    title_3 = 'presentations'
    array_4 = docsData_4;
    title_4= 'presentations'
  }else if(section === 'Help and Training'){
    array_1 = docsData_5;
    title_1 = 'Help Manuals'
    array_2 = docsData_6
    title_2 = 'EMR / EHR / VNA'
    array_3 = docsData_7
    title_3 = 'RIS / PACS'
    array_4 = docsData_8
    title_4 = 'CRM / ERP'
  }else if(section === 'Technical Documentations'){
    array_1 = docsData_9;
    title_1 = 'Technical Specs'
    array_2 = docsData_10;
    title_2 = 'Tender Specs.'
    array_3 = docsData_11;
    title_3 = 'Technical Docs.'
    array_4 = docsData_12 ;
    title_4 = 'Acquisition WS Connectivity'
  }else if(section === 'Other Documents'){
    array_1 = docsData_13;
    title_1 = 'Quality Certificates'
    array_2 = docsData_14;
    title_2 = 'Technical Specs'
    array_3 = docsData_15;
    title_3 = 'Other Documents'
    array_4 = docsData_16 ;
    title_4 = 'Questionaire'
  }
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}  
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
            <Link to='#' className={styles._headding}>{title_1}</Link>
              {
                array_1.map((ele,i)=>{return(
                  <DocItem key={i}  arr={ele.arr} title={ele.title}/>
                )})
              }
            </div>
            <div className={styles.__box_rightside}>
            <Link to='#' className={styles._headding}>{title_2}</Link>
              {
                array_2.map((ele,i)=>{return(
                  <DocItem key={i}  arr={ele.arr} title={ele.title}/>
                )})
              }
            </div>
          </div>
        </div>
        {/* Box 2  */}
          <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
            <Link to='#' className={styles._headding}>{title_3}</Link>
              {
                array_3.map((ele,i)=>{return(
                  <DocItem key={i}  arr={ele.arr} title={ele.title}/>
                )})
              }
            </div>
            <div className={styles.__box_rightside}>
            <Link to='#' className={styles._headding}>{title_4}</Link>
              {
                array_4.map((ele,i)=>{return(
                  <DocItem key={i}  arr={ele.arr} title={ele.title}/>
                )})
              }
            </div>
          </div>
        </div>
        {/* Box 3  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <Link to='/' className={styles._headding_5}>
                <FaHandHoldingHeart/> Thank you for being MILLENSYS Partner
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Box;
